import { createApiQuery } from '@/hooks/use-api-query';
import { get, post } from '@/libs/http';
import type { BagTabsRes } from '@/types/api/backpack/bag-tabs.d';
import type { BagItemsReq, BagItemsRes } from '@/types/api/backpack/bag-items.d';
import type { BagRedDotReq, BagRedDotRes } from '@/types/api/backpack/bag-red-dot.d';
import type { BagRedDotClearReq, BagRedDotClearRes } from '@/types/api/backpack/bag-red-dot-clear.d';
import type { BagItemRedDotClearReq, BagItemRedDotClearRes } from '@/types/api/backpack/bag-item-red-dot-clear.d';

export const getBagTabs = () => get<BagTabsRes>('/hall/v1/bag/tabs');

export const getBagItems = (params: BagItemsReq) =>
  get<BagItemsRes>('/hall/v1/bag/items', { params });

export const getBagCount = (params: BagRedDotReq) =>
  get<BagRedDotRes>('/hall/v1/bag/red-dot', { params });

export const clearBagRedDot = (data: BagRedDotClearReq) =>
  post<BagRedDotClearRes>('/hall/v1/bag/red-dot/clear', data);

export const clearSingleBagRedDot = (data: BagItemRedDotClearReq) =>
  post<BagItemRedDotClearRes>('/hall/v1/bag/item/red-dot/clear', data);

export const useGetBagTabs = createApiQuery(getBagTabs, (params) => ['bag-tabs', params]);
export const useGetBagCount = createApiQuery(getBagCount, (params) => ['bag-count', params]);
